import { SVGProps } from 'react'

export const PPTIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4 4C4 1.79086 5.79086 0 8 0H24L36 12V36C36 38.2091 34.2091 40 32 40H8C5.79086 40 4 38.2091 4 36V4Z"
      fill="#E62E05"
    />
    <path
      opacity="0.3"
      d="M24 0L36 12H28C25.7909 12 24 10.2091 24 8V0Z"
      fill="white"
    />
    <path
      d="M11.7359 32V25.4545H14.3183C14.8147 25.4545 15.2377 25.5494 15.5871 25.739C15.9365 25.9265 16.2029 26.1875 16.3861 26.522C16.5715 26.8544 16.6642 27.2379 16.6642 27.6726C16.6642 28.1072 16.5704 28.4908 16.3829 28.8232C16.1954 29.1555 15.9237 29.4144 15.5679 29.5998C15.2142 29.7852 14.786 29.8778 14.2831 29.8778H12.6372V28.7688H14.0594C14.3257 28.7688 14.5452 28.723 14.7178 28.6314C14.8925 28.5376 15.0225 28.4087 15.1077 28.2447C15.195 28.0785 15.2387 27.8878 15.2387 27.6726C15.2387 27.4553 15.195 27.2656 15.1077 27.1037C15.0225 26.9396 14.8925 26.8129 14.7178 26.7234C14.5431 26.6317 14.3215 26.5859 14.053 26.5859H13.1198V32H11.7359ZM17.563 32V25.4545H20.1454C20.6419 25.4545 21.0648 25.5494 21.4142 25.739C21.7637 25.9265 22.03 26.1875 22.2132 26.522C22.3986 26.8544 22.4913 27.2379 22.4913 27.6726C22.4913 28.1072 22.3976 28.4908 22.2101 28.8232C22.0226 29.1555 21.7509 29.4144 21.3951 29.5998C21.0414 29.7852 20.6131 29.8778 20.1103 29.8778H18.4643V28.7688H19.8865C20.1529 28.7688 20.3723 28.723 20.5449 28.6314C20.7196 28.5376 20.8496 28.4087 20.9348 28.2447C21.0222 28.0785 21.0659 27.8878 21.0659 27.6726C21.0659 27.4553 21.0222 27.2656 20.9348 27.1037C20.8496 26.9396 20.7196 26.8129 20.5449 26.7234C20.3702 26.6317 20.1486 26.5859 19.8801 26.5859H18.9469V32H17.563ZM23.1409 26.5955V25.4545H28.5166V26.5955H26.5127V32H25.1448V26.5955H23.1409Z"
      fill="white"
    />
  </svg>
)
